// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1rpRY","overflowing":"ReadFullNote_overflowing__2_Mjt"};